
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gjM8W_45yNA2wWUIW2xfmbmnoa6E7rQQXxgJMBveiNGBv0Meta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexqIJwh3izinBOLaeDpLK8M_45lTWL3Xd1pXrrna1wmIl7AMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search0gXtxAOiy2qwTwVX1jKbkwVR9K7Ug701jurCVJCJbRwMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexEinrMo5GGMQrL5NO_ByIkMfcAhA3LvHlJPc1ExcbEJkMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93txRa4ptvfibK8jTyLliqNo9COo_4Cy6mAIInDi_jts4Meta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index3mRlzxjYqy2nzK4Vu4Th4S7xMBwPbe5PoD44zQWCsL8Meta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93c63H7i3B5cpqAMX_45ppI939sty08Wg9sy6mHWFMtB_453wMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexFcI06TPWVOlKB1gw7f5y9M84meg6n_454Oy2lRzdwCLwIMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93bxwdlV8JqWOG2ZvGZnJnAdhb7jr1jTrjzII1BsQ8_45NUMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexRUfJIRP6Ai_DPmscK4pc481aEzmCggcXzgTNdM23rOcMeta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexBp9BEAm1nRXXalgSUsiCUiaSmLzYLxz_45wC9tU6wt938Meta } from "/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index3mRlzxjYqy2nzK4Vu4Th4S7xMBwPbe5PoD44zQWCsL8Meta || {},
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexFcI06TPWVOlKB1gw7f5y9M84meg6n_454Oy2lRzdwCLwIMeta || {},
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexRUfJIRP6Ai_DPmscK4pc481aEzmCggcXzgTNdM23rOcMeta || {},
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexBp9BEAm1nRXXalgSUsiCUiaSmLzYLxz_45wC9tU6wt938Meta || {},
    component: () => import("/codebuild/output/src2719938992/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]